import {
  ShipmentEntryType,
  DropOffTypeKey,
  LabelOptionsRewriteModel,
  DropOffType,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

export const isReturnShipment = (labelOptions, labelOptionsRewrite) => {
  return (
    labelOptions?.shipmentEntryType === ShipmentEntryType.Return ||
    labelOptionsRewrite?.shipmentEntryType === ShipmentEntryType.Return
  )
}

export const isPackageTypeLabelTypeFlow = (labelOptions, labelOptionsRewrite) => {
  return (
    (labelOptions?.availableLabelTypes &&
      labelOptions.availableLabelTypes.length > 1 &&
      labelOptions.dropOffTypes &&
      labelOptions.dropOffTypes.length > 1) ||
    labelOptionsRewrite?.dropOffs?.some(
      dropOff =>
        dropOff.options?.some(option => option.labelTypes?.length > 1) &&
        dropOff.options.length > 1,
    )
  )
}

export const isReusablePackagingFlowEnabled = (labelOptions, labelOptionsRewrite) => {
  const findReusablePackageDimensions = options => {
    const dropOffWithReusablePackage = options?.dropOffs?.find(dropOff =>
      dropOff.options?.some(option => option.freeReusablePackagingAvailable),
    )

    const reusablePackageOption = dropOffWithReusablePackage?.options?.find(
      option => option.freeReusablePackagingAvailable,
    )

    return reusablePackageOption ? reusablePackageOption.formattedDimensions : null
  }

  const fromOldStructure = options =>
    options?.dropOffTypes?.some(
      ({ key }) => key === DropOffTypeKey.ReusablePackage || key === DropOffTypeKey.MyOwnPackage,
    )

  const dimensionsFromNewStructure =
    findReusablePackageDimensions(labelOptions) ||
    findReusablePackageDimensions(labelOptionsRewrite)

  return {
    enabled:
      fromOldStructure(labelOptions) ||
      fromOldStructure(labelOptionsRewrite) ||
      Boolean(dimensionsFromNewStructure),
    dimensions: dimensionsFromNewStructure,
  }
}

export const isTypeMailbox = (labelOptionsRewrite?: LabelOptionsRewriteModel) => {
  return labelOptionsRewrite?.dropOffs.some(dropOff =>
    dropOff.options.some(option => option.type === DropOffType.Mailbox),
  )
}

export const isDropOffMapEnabled = (labelOptionsRewrite?: LabelOptionsRewriteModel) => {
  return labelOptionsRewrite?.dropOffs.some(dropOff => dropOff.providesNearbyDropOffPoints)
}
